import { Permission } from 'api/planning';
import { RouteDefinition } from './types';
import { OrganisationStructureLevel } from 'const';

type Routes = 'examDatesForLocations';

export const getExamDatesForLocationsRoutes: (
  basePath: string
) => Record<Routes, RouteDefinition> = (basePath) => ({
  examDatesForLocations: {
    path: '',
    absolutePath: basePath,
    requiresAny: [Permission.ViewPlanningSession, Permission.ManagePlanningSession],
    filters: [
      {
        required: OrganisationStructureLevel.Centre,
      },
    ],
  },
});
